"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearRecentSearch = clearRecentSearch;
exports.default = watchers;
exports.getAutoSuggestionSearch = getAutoSuggestionSearch;
exports.getFacilitySearch = getFacilitySearch;
exports.getRecentAndTrendingSearches = getRecentAndTrendingSearches;
exports.getSearchAutoSuggestions = getSearchAutoSuggestions;
exports.getSpecialitySearch = getSpecialitySearch;
exports.getTeleSearch = getTeleSearch;
exports.topTrendSearch = topTrendSearch;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    count: home many recent search items are required
*/

function* getRecentAndTrendingSearches(request) {
  try {
    const {
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.GET_RECENT_TRENDING_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getRecentAndTrendingSearchData, requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_RECENT_TRENDING_SEARCH_API.success(mainResponse));
    request.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_RECENT_TRENDING_SEARCH_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}

/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    queryParam: search query parameter
*/

function* getSearchAutoSuggestions(request) {
  try {
    const {
      onSuccess,
      queryParam
    } = request.data;
    yield (0, _effects.put)(actions.GET_SEARCH_AUTOSUGGESTION_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getSearchAutoSuggestions, queryParam, tokenData);
    yield (0, _effects.put)(actions.GET_SEARCH_AUTOSUGGESTION_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse.suggestions) {
      onSuccess((0, _utils.getUpdatedSearchDataForConsultADoctor)(mainResponse.suggestions));
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SEARCH_AUTOSUGGESTION_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}

/*
    Request Params
    onSuccess: success callback
*/

function* clearRecentSearch(request) {
  try {
    const {
      queryParam
    } = request.data;
    yield (0, _effects.put)(actions.CLEAR_RECENT_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.clearRecentSearch, queryParam, tokenData);
    yield (0, _effects.put)(actions.CLEAR_RECENT_SEARCH_API.success(mainResponse));
    if (request && request.data && request.data.onSuccess) {
      request.data.onSuccess();
    }
  } catch (err) {
    yield (0, _effects.put)(actions.CLEAR_RECENT_SEARCH_API.failure(err));
  }
}

/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
*/

function* topTrendSearch(request) {
  try {
    yield (0, _effects.put)(actions.TOP_TREND_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getTopTrendSearch, request.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.TOP_TREND_SEARCH_API.success(mainResponse));
    request.data.onSuccess(mainResponse);
  } catch (err) {
    yield (0, _effects.put)(actions.TOP_TREND_SEARCH_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getTeleSearch(request) {
  const {
    showLoader = true
  } = request === null || request === void 0 ? void 0 : request.data;
  try {
    if (showLoader) {
      yield (0, _effects.put)(actions.TELE_SEARCH_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getTeleSearch, request.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.TELE_SEARCH_API.success(mainResponse));
    if (request && request.data && request.data.onSuccess) {
      request.data.onSuccess(mainResponse !== null && mainResponse !== void 0 ? mainResponse : []);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.TELE_SEARCH_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getSpecialitySearch(request) {
  const {
    showLoader = true
  } = request === null || request === void 0 ? void 0 : request.data;
  try {
    if (showLoader) {
      yield (0, _effects.put)(actions.SPECIALITY_SEARCH_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getSpecialitySearch, request.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.SPECIALITY_SEARCH_API.success(mainResponse));
    if (request && request.data && request.data.onSuccess) {
      request.data.onSuccess(mainResponse !== null && mainResponse !== void 0 ? mainResponse : []);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.SPECIALITY_SEARCH_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getFacilitySearch(request) {
  const {
    showLoader = true
  } = request === null || request === void 0 ? void 0 : request.data;
  try {
    if (showLoader) {
      yield (0, _effects.put)(actions.FACILITY_SEARCH_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getFacilitySearch, request.data.requestParams, tokenData);
    yield (0, _effects.put)(actions.FACILITY_SEARCH_API.success(mainResponse));
    if (request && request.data && request.data.onSuccess) {
      request.data.onSuccess(mainResponse !== null && mainResponse !== void 0 ? mainResponse : []);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.FACILITY_SEARCH_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}

/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    count: home many recent search items are required
*/

function* getAutoSuggestionSearch(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAutoSuggestionSearch, requestParams, tokenData);
    if (onSuccess && mainResponse && mainResponse.suggestions) {
      request.data.onSuccess((0, _utils.getUpdatedSearchDataForConsultADoctor)(mainResponse.suggestions));
    }
  } catch (err) {
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* watchers() {
  yield (0, _effects.takeLatest)(actions.GET_RECENT_TRENDING_SEARCH, getRecentAndTrendingSearches);
  yield (0, _effects.takeLatest)(actions.GET_SEARCH_AUTOSUGGESTION, getSearchAutoSuggestions);
  yield (0, _effects.takeLatest)(actions.CLEAR_RECENT_SEARCH, clearRecentSearch);
  yield (0, _effects.takeLatest)(actions.TOP_TREND_SEARCH, topTrendSearch);
  yield (0, _effects.takeLatest)(actions.TELE_SEARCH, getTeleSearch);
  yield (0, _effects.takeLatest)(actions.SPECIALITY_SEARCH, getSpecialitySearch);
  yield (0, _effects.takeLatest)(actions.FACILITY_SEARCH, getFacilitySearch);
  yield (0, _effects.takeLatest)(actions.GET_AUTO_SUGGESTION_SEARCH, getAutoSuggestionSearch);
}